import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/domel-lobby.png'


const _hoisted_1 = {
  id: "home",
  class: "relative z-10"
}
const _hoisted_2 = { class: "relative min-h-screen w-full flex items-center justify-center py-32" }
const _hoisted_3 = { class: "relative container-default max-w-2xl z-20 space-y-12 mt-32" }
const _hoisted_4 = { class: "max-w-lg w-full mx-auto space-y-8 flex flex-col items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-50 text-center" }, " A 3D-rendered collection of 250 NFTs representing the diversity of ethnic heritage, cherishing education and learning, with a crossover of college-themed and urban fashion aesthetics ", -1)
const _hoisted_6 = { class: "absolute bottom-0 left-0 w-full py-8 z-20" }
const _hoisted_7 = { class: "container-default mx-auto flex items-center justify-between" }
const _hoisted_8 = { class: "flex flex-col md:flex-row md:space-x-3 md:items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "block text-neutral-400" }, "Current phase:", -1)
const _hoisted_10 = { class: "flex items-center space-x-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "relative h-3 w-3 flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "animate-ping absolute block inset-0 rounded-full bg-orange-400 opacity-50" }),
  /*#__PURE__*/_createElementVNode("span", { class: "relative block h-2 w-2 rounded-full bg-orange-400" })
], -1)
const _hoisted_12 = { class: "block font-bold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 left-0 -bottom-60 w-full flex z-0 overflow-hidden" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "block absolute inset-0 bg-gradient-to-t from-black via-black/75 md:via-black/50 z-10" }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "flex-1 object-cover object-top",
    src: _imports_0,
    alt: "Dripversity Lobby"
  })
], -1)

import DripversityIcon from "@/components/icons/DripversityIcon.vue";
import { useSalePhase } from "@/composables/useSalePhase";
import AppButton from "@/components/app/AppButton.vue";
import AppCta from "@/components/app/AppCta.vue";
import { PlayIcon } from "@heroicons/vue/24/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeHero',
  setup(__props) {

const { currentSalePhase, stringify } = useSalePhase();

return (_ctx: any,_cache: any) => {
  const _directive_animate = _resolveDirective("animate")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(DripversityIcon, { class: "w-full text-blue stroke-creme" }),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(AppCta)
        ])
      ])), [
        [
          _directive_animate,
          void 0,
          void 0,
          { stagger: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(stringify)(_unref(currentSalePhase))), 1)
          ])
        ])
      ])
    ]),
    _hoisted_13
  ]))
}
}

})